export const USERNAME_REQUIRED = "Il campo username è obbligatorio";

export const PASSWORD_REQUIRED = "Il campo password è obbligatorio";
